<script setup lang="ts">
defineProps<{ done: boolean }>()
</script>

<template>
  <UIcon
    v-if="done"
    name="check"
    size="xxs"
    class="scale-[0.8] rounded-full bg-white p-[2.75px] text-[--theme-darkest]"
    :aria-label="done ? 'Artikkel lest' : 'Artikkel ikke lest'"
  />
  <UIcon
    v-else
    name="circle-hollow"
    size="xs"
    aria-label="Artikkel ikke lest"
  />
</template>
